<div class="entity-access-host" [attr.data-entity-type]="entityType()">
  <ng-content />
</div>
